/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSageIntacctTasksInput = {
    sageIntacctProjectId?: string | null | undefined;
    sageIntacctItemId?: string | null | undefined;
    forecastProjectId?: string | null | undefined;
    taskIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateSageIntacctTasksMutationVariables = {
    input: CreateSageIntacctTasksInput;
};
export type CreateSageIntacctTasksMutationResponse = {
    readonly createSageIntacctTasks: {
        readonly tasks: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly sageIntacctId: string | null;
            } | null;
        } | null> | null;
    } | null;
};
export type CreateSageIntacctTasksMutation = {
    readonly response: CreateSageIntacctTasksMutationResponse;
    readonly variables: CreateSageIntacctTasksMutationVariables;
};



/*
mutation CreateSageIntacctTasksMutation(
  $input: CreateSageIntacctTasksInput!
) {
  createSageIntacctTasks(input: $input) {
    tasks {
      node {
        id
        name
        sageIntacctId
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSageIntacctTasksInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSageIntacctTasksPayload",
    "kind": "LinkedField",
    "name": "createSageIntacctTasks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTypeEdge",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageIntacctTasksMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageIntacctTasksMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSageIntacctTasksMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageIntacctTasksMutation(\n  $input: CreateSageIntacctTasksInput!\n) {\n  createSageIntacctTasks(input: $input) {\n    tasks {\n      node {\n        id\n        name\n        sageIntacctId\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '959f66845403914ff9ba2fd1885923d0';
export default node;
